import { useEffect, useState } from "react";

/**
 * Easter egg: type "gtl" anywhere on the page to trigger a
 * brief glitch celebration.
 */
export const EasterEgg = () => {
  const [buf, setBuf] = useState("");
  const [active, setActive] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
      const k = e.key.toLowerCase();
      if (!/^[a-z]$/.test(k)) return;
      setBuf((b) => {
        const next = (b + k).slice(-3);
        if (next === "gtl") {
          setActive(true);
          setTimeout(() => setActive(false), 2200);
          return "";
        }
        return next;
      });
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  if (!active) return null;
  return (
    <div className="fixed inset-0 pointer-events-none z-[90] flex items-center justify-center animate-fade-in" data-testid="easter-egg">
      <div className="absolute inset-0 bg-cyan-400/5 mix-blend-screen" />
      <div
        className="text-[16vw] font-bold tracking-tighter gradient-text opacity-70"
        style={{ animation: "gtl-glitch 0.2s steps(2) 6", fontFamily: "'Outfit', sans-serif" }}
      >
        GTL
      </div>
    </div>
  );
};

export default EasterEgg;
